import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Header from '../../components/header';
import { Button } from 'carbon-components-react';
import InsurancePlans from './insurance-plans';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import {Edit16 } from '@carbon/icons-react';
import { Link,} from 'carbon-components-react';
import Attachment from '../../components/attachment';
import { AttachmentType } from '../../components/enums/attachment-type';
import useMsalApi from '../../components/use-msal-api';
import { PlanType } from '../../components/enums/plan-type';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import { isEoiRequired } from '../../components/attachment-validator';
import { format, parseISO } from 'date-fns';

const VoluntaryLife = ({volLife, spouseLife, childLife, reset, attachments, setAttachments}) => {
    const {watch} = useFormContext(); 
    const [spouseBenefitDisabled, setSpouseBenefitDisabled] = useState(true);
    const [childBenefitDisabled, setChildBenefitDisabled] = useState(true);
    const [empAmount, setEmpAmount] = useState();
    const employeeBenefit = watch("employeeBenefit");
    const spouseBenefit = watch("spouseBenefit");
    const employeeAmount = watch("employeeAmount");
    const spouseAmount = watch("spouseAmount");
    const navigate = useNavigate();
    const enrollments = useSelector((s) => s.enrollments);  
    const [callApi] = useMsalApi();
    const [unmodifiedVolLifeAmount, setUnmodifiedVolLifeAmount] = useState();
    const [unmodifiedSpouseLifeAmount, setUnmodifiedSpouseLifeAmount] = useState();
    const [volEmpHelperText,setVolEmpHelperText] = useState("");
    useEffect(() => {
        setSpouseBenefitDisabled(employeeBenefit);
        setChildBenefitDisabled(employeeBenefit);
        if(enrollments?.contacts?.filter(s => s.relationship?.id === 'S' || s.relationship?.id === 'D').length < 1)
            setSpouseBenefitDisabled(false);
        if(enrollments?.contacts?.filter(s => s.relationship?.id === 'C' || s.relationship?.id === 'R').length < 1)
            setChildBenefitDisabled(false);
    }, [employeeBenefit,reset]);


    useEffect(() => {
        setEmpAmount(employeeAmount);
    }, [employeeAmount,reset]);

    useEffect(() => {
        if(Array.isArray(enrollments))
            return;
        if(enrollments.enrollmentTypeId === EnrollmentType.NewHire)
            setVolEmpHelperText("(up to $200,000 with no EOI — Evidence of Insurability)");
        getUnmodified();
    }, [enrollments]);

    const getUnmodified = async () => {
        const results = await callApi(`Enrollments/UnmodifiedSelections/${enrollments.employee.id}/${format(
            parseISO(enrollments.effectiveDate),
            "yyyy-MM-dd"
          )}`, "GET");
        if(results.error)
            return;
        
        setUnmodifiedVolLifeAmount(results?.find(s => s.planType === PlanType.VoluntaryLife)?.amount);
        setUnmodifiedSpouseLifeAmount(results?.find(s => s.planType === PlanType.SpouseLife)?.amount);
    }
    
   return ( 
        <>
        <Header title="Voluntary — Employee Paid" secondary={true} />
        
            {enrollments?.enrollmentTypeId === EnrollmentType.NewHire ? <p className='text-sm'>
            As a new hire you have up to 30 days from start date to enroll in voluntary life insurance
            without any EOI (Evidence of Insurability) up to $200,000.
        </p> :<></> }
        <div className="pl-4">

        <InsurancePlans plan={volLife} fieldName="employeeBenefit" fieldLabel="Employee Benefit" amountName="employeeAmount" unmodifiedAmount={unmodifiedVolLifeAmount} incrementAmount={10000} disabled={false} reset={reset}
            fieldDescription="Increments of $10,000 up to 5x annual salary with a maximum of $500,000" 
            amountDescription={<>Increments of $10,000<br /></>} />
        <div className='ml-8 mt-4'>
            {isEoiRequired(empAmount, unmodifiedVolLifeAmount, employeeBenefit, enrollments.enrollmentTypeId, 200000) ? 
                <div className='ml-3'>
                    <div className ='font-bold mb-3'>Evidence Of Insurability is required.</div>
                    <div className = 'text-gray-500 mb-3'>Please Complete Evidence Of Insurability</div>
                    <a className="underline" href="https://myeoi.standard.com/161980" target="_blank">Complete EOI</a>
                </div>
            : 
                <div/>
            }
        </div>
        {!employeeBenefit ?
        <div className='font-bold'>*Please note that you must enroll in the employee benefit in order to enroll spouse/domestic partner or child.</div>
        :<></>}
        {enrollments?.contacts?.filter(s => s.relationship?.id === 'S' || s.relationship?.id === 'D').length > 0 ?
            <></> 
         :
            <>
                <div className='text-danger mt-4'>Must add a Spouse/Domestic Partner to enable this option <Link kind="ghost" size="sm" role="button" renderIcon={Edit16} onClick={() => navigate("/Dependents")}></Link></div>
            </>
        }

        <InsurancePlans plan={spouseLife} fieldName="spouseBenefit" fieldLabel="Spouse/Domestic Partner Benefit" amountName="spouseAmount" unmodifiedAmount={unmodifiedSpouseLifeAmount} incrementAmount={5000} disabled={!spouseBenefitDisabled} reset={reset}
            fieldDescription="Increments of $5,000 up to 50% of employee benefit coverage with a maximum of $250,000"
            amountDescription="Guarantee issue amount is 50% of “Employee Benefit” up to $50,000" />
        <div className='ml-8 mt-4'>
            {isEoiRequired(spouseAmount, unmodifiedSpouseLifeAmount, spouseBenefit, enrollments.enrollmentTypeId, 50000) ? 
                <div className='ml-3'>
                    <div className ='font-bold mb-3'>Evidence Of Insurability is required.</div>
                    <div className = 'text-gray-500 mb-3'>Please Complete Evidence Of Insurability</div>
                    <a className="underline" href="https://myeoi.standard.com/161980" target="_blank">Complete EOI</a>
                </div>
            : 
                <div/>
            }
        </div>
        {enrollments?.contacts?.filter(s => s.relationship?.id === 'C' || s.relationship?.id === 'R').length > 0 ?
            <></>
        : 
            <>
                <div className='text-danger'>Must add a child(ren) to enable this option <Link kind="ghost" size="sm" role="button" renderIcon={Edit16} onClick={() => navigate("/Dependents")}></Link></div> 
            </>
        }
        <InsurancePlans plan={childLife} fieldName="childBenefit" fieldLabel="Child(ren)/Domestic Child(ren) Benefit" amountName="childAmount" incrementAmount={5000}  disabled={!childBenefitDisabled} reset={reset}
            fieldDescription="Increments of $5,000 up to a maximum of $10,000"
            amountDescription="Increments of $5,000" />
        </div>
        </>
     );
}
 
export default VoluntaryLife;